import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { LogoWithText } from './LogoWithText';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth, hasValidAuth } from '../auth/authContext';
import { LanguageDropdown } from './LanguageDropdown';
import LoginModal from './LoginModal';

const Header = () => {
  const { t } = useLanguage();
  const { isAuthenticated, authLoading } = useAuth();
  /** Profil yuklanayotganda ham sessiya bor bo'lsa panel havolasi (Kirish emas). */
  const showPanel = isAuthenticated || (authLoading && hasValidAuth());
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  const scrollToSection = (id) => {
    // Agar Contact sahifasida bo'lsa, avval bosh sahifaga o't
    if (location.pathname !== '/') {
      navigate('/');
      // Bosh sahifaga o'tgandan keyin section'ga scroll qilish uchun kichik kutish
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Bosh sahifada bo'lsa, to'g'ridan-to'g'ri scroll qil
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileNavClick = (id) => {
    setIsMobileMenuOpen(false);
    scrollToSection(id);
  };

  const handleLoginClick = () => {
    setIsMobileMenuOpen(false);
    if (showPanel) {
      navigate('/admin');
      return;
    }
    setIsLoginModalOpen(true);
  };

  const handleStartTrialClick = () => {
    setIsMobileMenuOpen(false);
    navigate('/contact');
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  /** Ochiq marketing sahifalar doim yorug‘; admin alohida Topbar orqali tema. */
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  return (
    <>
      <header className={`header ${isMobileMenuOpen ? 'menu-open' : ''}`}>
        <div className="header-container">
          <LogoWithText />
          <nav className="header-nav">
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>{t('navFeatures')}</a>
            <a href="#solutions" onClick={(e) => { e.preventDefault(); scrollToSection('solutions'); }}>{t('navSolutions')}</a>
            <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }}>{t('navPricing')}</a>
            <a href="#ai-analytics" onClick={(e) => { e.preventDefault(); scrollToSection('ai-analytics'); }}>{t('navAIAnalytics')}</a>
            <Link to="/contact">{t('navContact')}</Link>
          </nav>
          <div className="header-actions">
            <LanguageDropdown ariaLabel={t('adminLanguageLabel')} />
            {showPanel ? (
              <Link className="btn-secondary header-panel-link" to="/admin">{t('adminGoToPanel')}</Link>
            ) : (
              <button type="button" className="btn-secondary" onClick={handleLoginClick}>{t('btnLogin')}</button>
            )}
            <button className="btn-primary" onClick={handleStartTrialClick}>{t('btnStartFreeTrial')}</button>
          </div>
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Menyu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            <a href="#features" onClick={(e) => { e.preventDefault(); handleMobileNavClick('features'); }}>{t('navFeatures')}</a>
            <a href="#solutions" onClick={(e) => { e.preventDefault(); handleMobileNavClick('solutions'); }}>{t('navSolutions')}</a>
            <a href="#pricing" onClick={(e) => { e.preventDefault(); handleMobileNavClick('pricing'); }}>{t('navPricing')}</a>
            <a href="#ai-analytics" onClick={(e) => { e.preventDefault(); handleMobileNavClick('ai-analytics'); }}>{t('navAIAnalytics')}</a>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>{t('navContact')}</Link>
          </nav>
          <div className="mobile-actions">
            {showPanel ? (
              <Link className="btn-secondary header-panel-link" to="/admin" onClick={() => setIsMobileMenuOpen(false)}>{t('adminGoToPanel')}</Link>
            ) : (
              <button type="button" className="btn-secondary" onClick={handleLoginClick}>{t('btnLogin')}</button>
            )}
            <button className="btn-primary" onClick={handleStartTrialClick}>{t('btnStartFreeTrial')}</button>
            <LanguageDropdown ariaLabel={t('adminLanguageLabel')} />
          </div>
        </div>
      )}
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  );
};

export default Header;

